import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2', // Azul
    },
    secondary: {
      main: '#9c27b0', // Morado
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
})

export default theme
